export const FAV_OPEN_MODAL = 'FAV_OPEN_MODAL';
export const FAV_CLOSE_MODAL = 'FAV_CLOSE_MODAL';
export const FAV_SEARCH_IN_MODAL = 'FAV_SEARCH_IN_MODAL';
export const FAV_SEARCH_IN_MODAL_REQUEST = 'FAV_SEARCH_IN_MODAL_REQUEST';
export const FAV_SEARCH_IN_MODAL_SUCCESS = 'FAV_SEARCH_IN_MODAL_SUCCESS';
export const FAV_SEARCH_IN_MODAL_FAILED = 'FAV_SEARCH_IN_MODAL_FAILED';
export const FAV_SEARCH_IN_MODAL_LOAD_MORE = 'FAV_SEARCH_IN_MODAL_LOAD_MORE';
